import { Button, Spacer } from '@spritz-finance/ui'
import eth from '../../../../../assets/img/ethereum.svg'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'
import { useDirectPayContext } from '../context/DirectPayContext'
import { TokenImage } from '../TokenListItem'
import { nativeTokenImg } from './TokenSelectEmptyState'
import { ButtonsWrapper } from './ButtonsWrapper'
import { useWalletAction } from './useWalletAction'

const NoSelectedToken = () => {
    const { connectedNetwork } = useWeb3Connection()
    const action = useWalletAction()
    return (
        <ButtonsWrapper>
            <Button.CTA disabled>
                {action} <Spacer width={4} />
                <TokenImage src={nativeTokenImg[connectedNetwork!] ?? eth} />
            </Button.CTA>
        </ButtonsWrapper>
    )
}

export const FormSubmitButton = ({ submitting }: { submitting: boolean }) => {
    const { selectedToken, tokenModule } = useDirectPayContext()

    if (!selectedToken) return <NoSelectedToken />

    return tokenModule?.content({ submitting })
}
